"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Banner_1 = __importDefault(require("./Banner"));
var svg_1 = require("./svg");
var TooltipArrow_1 = __importDefault(require("./TooltipArrow"));
var useCheckDisruption_1 = __importDefault(require("./useCheckDisruption"));
var useConsumerDisruptionContext_1 = __importDefault(require("./useConsumerDisruptionContext"));
/**
 * @description Button and Banner displayed during outage to inform customers
 * @param dependencies
 * List of services that the application depends on. Banner will be displayed if any of them is experiencing an incident
 * @param externalControl
 * A boolean that enables us to trigger the banner remotely. For example with LaunchDarkly. Allows us to display banner in case an incident occurs that is not in one of the listed dependencies (optional)
 * @param size
 * A number to designate the size of the button in pixels (optional)
 * @param pollingRate
 * A number to designate the rate of polling in milliseconds (optional)
 * @param buttonContainerStyle
 * A CSS Styling object to style the div wrapping the button component (optional)
 * @param bannerContainerStyle
 * A CSS Styling object to style the div wrapping the banner component (optional)
 */
var ConsumerDisruptionButton = function (_a) {
    var dependencies = _a.dependencies, externalControl = _a.externalControl, size = _a.size, pollingRate = _a.pollingRate, buttonContainerStyle = _a.buttonContainerStyle, bannerContainerStyle = _a.bannerContainerStyle;
    var existsDisruption = (0, useCheckDisruption_1.default)(dependencies, pollingRate);
    var shouldDisplay = existsDisruption || (externalControl !== null && externalControl !== void 0 ? externalControl : false);
    var _b = (0, useConsumerDisruptionContext_1.default)(), isOpen = _b[0], setIsOpen = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { onClick: function () {
                setIsOpen(!isOpen);
            } },
            shouldDisplay && (react_1.default.createElement("div", { style: buttonContainerStyle !== null && buttonContainerStyle !== void 0 ? buttonContainerStyle : $buttonContainer },
                react_1.default.createElement(svg_1.Warning, { height: size, width: size }))),
            shouldDisplay && isOpen && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { style: bannerContainerStyle !== null && bannerContainerStyle !== void 0 ? bannerContainerStyle : $bannerContainer },
                    react_1.default.createElement(Banner_1.default, { setIsOpen: setIsOpen })),
                react_1.default.createElement(TooltipArrow_1.default, null))))));
};
exports.default = ConsumerDisruptionButton;
var $buttonContainer = {
    alignItems: 'center',
    justifyContent: 'center',
};
var $bannerContainer = {
    zIndex: 200,
    position: 'absolute',
    right: 15,
    maxWidth: 500,
    marginTop: 15,
    marginLeft: 15,
};
